import React from 'react';
import { Box, TextField } from '@mui/material';

export function HtmlEditor({ value, onChange }) {
  return (
    <TextField
      multiline
      fullWidth
      minRows={4}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Éditez votre contenu HTML ici..."
    />
  );
}